import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import ClientDetail from './clientDetail';
import ClientsList from './clientsList';

const ClientsRouter = (): ReactElement => (
  <Routes>
    <Route path=":clientId" element={<ClientDetail tab="overview" />} />
    <Route path=":clientId/cost" element={<ClientDetail tab="cost" />} />
    <Route path="*" element={<ClientsList />} />
  </Routes>
);

export default ClientsRouter;
